import { Modal, ModalBody } from "@velaro/velaro-component-lib";
import IconNotificationsIndicator from "@/icons/IconNotificationsIndicator";
import React from "react";
import { PrimaryButton, SecondaryButton } from "@/components/ds";

;

interface Props {
  show: boolean;
  onClose(): void;
  onDeactivate(): void;
}

export default function DeactivateUserModal(props: Props) {
  function handleSubmit() {
    props.onDeactivate();
    props.onClose();
  }

  return (
    <Modal show={props.show}>
      <ModalBody>
        <div className="flex justify-center p-8">
          <div>
            <div className="flex justify-center">
              <IconNotificationsIndicator className="w-8 h-8 text-sweet-orange-500" />
            </div>
            <div className="m-4">
              Are you sure you want to deactivate this user?
            </div>
            <div className="p-4 flex mt-8 justify-center">
              <div className="mr-2">
                <SecondaryButton
                  onClick={() => props.onClose()}
                  label="Cancel"
                />
              </div>
              <PrimaryButton
                onClick={() => handleSubmit()}
                label="Deactivate user"
              />
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
